import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '../../../shared/interfaces/shared.module';

@Component({
  selector: 'app-rmm-alert',
  templateUrl: './rmm-alert.component.html',
  styleUrls: ['./rmm-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule]
})
export class RmmAlertComponent {
  public dialogRef = inject(MatDialogRef<RmmAlertComponent>);
  public data = inject(MAT_DIALOG_DATA);

  close(data): void {
    this.dialogRef.close(data);
  }

}
